import NvSwitch from 'shared/components/inputs/nv-switch';
import t from 'react-translate';
import { css } from '@emotion/react';
import { gray4 } from 'styles/global_defaults/colors';
import { halfSpacing, quarterSpacing } from 'styles/global_defaults/scaffolding';
import { useEffect, useState } from 'react';

type Props = {
  initialValue: boolean,
  onChange: (newChecked: boolean) => void,
  disabled?: boolean,
};

const waitlistStyles = css`
  align-items: center;
  padding: ${halfSpacing}px 0 ${quarterSpacing}px;
  .switch {
    margin-right: ${halfSpacing}px;
  }
  .text-body {
    &.disabled {
      color: ${gray4} !important;
    }
  }
`;

const WaitlistSwitch = (props: Props) => {
  const { onChange, initialValue, disabled } = props;
  const [value, setValue] = useState<boolean>(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleSwitchChange = (newChecked: boolean) => {
    setValue(newChecked);
    onChange(newChecked);
  };

  return (
    <div css={waitlistStyles} className='waitlist-switch d-flex'>
      <NvSwitch
        checked={value}
        onChange={handleSwitchChange}
        disabled={disabled}
        enabledLabel={t.SHARED.ON().toUpperCase()}
        disabledLabel={t.SHARED.OFF().toUpperCase()}
        className='switch'
      />
      <span className={`text-body ${disabled ? ' disabled' : ''}`}>
        {t.COURSES.FORM.ENROLLMENT_LIMIT.WAITLIST.ENABLE()}
      </span>
    </div>
  );
};

export default WaitlistSwitch;
